"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentProcessorApi = exports.DocumentProcessorClient = void 0;
var tslib_1 = require("tslib");
var model_manager_1 = require("../../core/model-manager");
var processor_1 = require("../../document-processor/processor");
var processor_2 = require("../../document-processor/public/processor");
var field_client_request_manager_1 = require("../model/fields/field-client-request-manager");
var DocumentProcessorClient = (function (_super) {
    tslib_1.__extends(DocumentProcessorClient, _super);
    function DocumentProcessorClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentProcessorClient.prototype.createFieldRequestManager = function () {
        var options = new field_client_request_manager_1.FieldClientRequestManagerOptions(null, function () { return false; }, this.onCalculateDocumentVariable ? this.onCalculateDocumentVariable : function () { }, function () { });
        return new field_client_request_manager_1.FieldClientRequestManager(options);
    };
    DocumentProcessorClient.prototype.createModelManager = function (model, richOptions) {
        return new model_manager_1.ClientModelManager(model, richOptions, this);
    };
    return DocumentProcessorClient;
}(processor_1.DocumentProcessorBase));
exports.DocumentProcessorClient = DocumentProcessorClient;
var DocumentProcessorApi = (function (_super) {
    tslib_1.__extends(DocumentProcessorApi, _super);
    function DocumentProcessorApi(options) {
        var _this = _super.call(this) || this;
        _this._processor = new DocumentProcessorClient(options);
        return _this;
    }
    return DocumentProcessorApi;
}(processor_2.DocumentProcessorBaseApi));
exports.DocumentProcessorApi = DocumentProcessorApi;
